import { useParams } from 'react-router-dom';
import { GeneralLedgerSidepanel } from '@ui/src';
import { useAppSelector } from '@store';
import useProblemGLTrasnaction from './hooks/use-gl';

const ProblemGLTransactionHOC = ({
  backPath,
}: {
  backPath: string;
}): React.JSX.Element => {
  const {
    transaction,
    transactionChangeLogsPagination,
    transactionChangeLogs,
  } = useAppSelector((state) => state.customersProblemTransactions.gl);
  const { baseCurrency } = useAppSelector(
    (state) => state.customersDictionaries,
  );
  const { users } = useAppSelector((state) => state.administrationDictionaries);
  const { currencies: currenciesList, activePermissions } = useAppSelector(
    (state) => state.root,
  );

  const { customerId, transactionId } = useParams();

  const {
    panelIsOpen,
    handleClose,
    isLoading,
    isFetching,
    changeLogsIsLoading,
    changeLogsIsFetching,
    getTransactionChangeLogsAction,
  } = useProblemGLTrasnaction({
    transactionId,
    customerId,
    transaction,
    backPath,
  });

  return (
    <GeneralLedgerSidepanel
      panelIsOpen={panelIsOpen}
      handleClose={handleClose}
      transaction={transaction}
      isLoading={isLoading || isFetching}
      title="GL Transaction"
      currenciesList={currenciesList}
      baseCurrency={baseCurrency}
      sidepanelExpandedKey="problem-gl"
      activePermission={activePermissions}
      users={users}
      changeLogsIsLoading={changeLogsIsLoading}
      changeLogsIsFetching={changeLogsIsFetching}
      getTransactionChangeLogs={getTransactionChangeLogsAction}
      transactionChangeLogsPagination={transactionChangeLogsPagination}
      changeLogs={transactionChangeLogs}
    />
  );
};

export default ProblemGLTransactionHOC;
